import { FieldType, ViewModelBase } from "@shoothill/core";
import { RDDV2ListFilterParamsModel } from "./RDDV2ListFilterParamsModel";

export class RDDV2FilterViewModel extends ViewModelBase<RDDV2ListFilterParamsModel> {
    private static _intsance: RDDV2FilterViewModel;
    public static get Instance() {
        return this._intsance || (this._intsance = new this());
    }

    constructor() {
        super(new RDDV2ListFilterParamsModel(), false);
        this.setDecorators(RDDV2ListFilterParamsModel);
    }

    public async isFieldValid(fieldName: keyof FieldType<RDDV2ListFilterParamsModel>): Promise<boolean> {
        const { isValid, errorMessage } = await this.validateDecorators(fieldName);

        this.setError(fieldName, errorMessage);
        this.setValid(fieldName, isValid);

        return isValid;
    }

    public afterUpdate: undefined;
    public beforeUpdate: undefined;
}
